/** VERSION: 0.0.2 Please do not delete this line. Thank you! **/

/* eslint-disable */
// Fix the confict suggestion search in Debut theme
// if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

// Override Settings
var urlParams = new URLSearchParams(location.search);
var isFiltering = urlParams.has("")
for (var key of urlParams.keys()) {
	if (key.includes("pf_p")) {
		isFiltering = true;
		break;
	}
}

var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: !isFiltering, // Plug: Causes an error.
		// Placeholder
		showPlaceholderProductList: isFiltering,
		placeholderProductPerRow: 3,
		placeholderProductGridItemClass: 'product-card', // Plug: changed.
		enableOTP: false, // Plug: changed.
		separateRefineByFromFilter: true,
		filterTreeMobileStyle: 'style3', // 'style2', 'style3',
		equal_height: boostPFSThemeConfig.custom.equal_height,
		cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position,
		defaultDisplay: boostPFSThemeConfig.custom.product_item_type
	},
	selector: {
		otpButtons: '.boost-pfs-filter-product-item-image'
	}
};

(function() {
	var PlugUtils = PLUG.import("Utils");
	var ProductCard = PLUG.import("ProductCard");
	var itemIndex = 0;

	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		firstVariant = {},
		boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
		boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices

		// Convert images to array
		images = data.images_info;

		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		// return;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		var variant = data.variants[0];

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
		itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data, itemIndex));
		itemHtml = itemHtml.replace(/{{itemSku}}/g, variant.sku);

		// console.log(data);
		var compareAtPrice = variant.compare_at_price * 100;
		var price = variant.price * 100;
    

		if (data.available) {
			itemHtml = itemHtml.replace(/{{itemCompareAtPrice}}/g, ProductCard.buildCompareAtPriceEle(price, compareAtPrice, true));
			itemHtml = itemHtml.replace(/{{itemPrice}}/g, ProductCard.buildPriceEle(price, compareAtPrice, true));
			itemHtml = itemHtml.replace(/{{itemSavings}}/g, ProductCard.buildSavingsEle(price, compareAtPrice, true));
		} else {
			const soldOutLabel = "<span class='product-card-sold-out-label'>Sold Out</span>";
			itemHtml = itemHtml.replace(/{{itemCompareAtPrice}}/g, ProductCard.buildCompareAtPriceEle(0, 0, true));
			itemHtml = itemHtml.replace(/{{itemPrice}}/g, soldOutLabel);
			itemHtml = itemHtml.replace(/{{itemSavings}}/g, ProductCard.buildSavingsEle(0, 0, true));
		}

		// Add Review
		// if (typeof Integration === 'undefined' ||
		// 	(typeof Integration != 'undefined' &&
		// 		typeof Integration.hascompileTemplate == 'function' &&
		// 		!Integration.hascompileTemplate('reviews'))) {
		// }
		itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		// console.log({data});

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		// itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildProductItemUrl(data));

		itemIndex += 1;

		return itemHtml;
	};


	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildGridWidthClass() {
		var gridWidthClass = '';
		// On PC
		switch (boostPFSThemeConfig.custom.products_per_row) {
			case 2:
				gridWidthClass = 'boost-pfs-filter-grid-width-2';
				break;
			case 3:
				gridWidthClass = 'boost-pfs-filter-grid-width-3';
				break;
			case 5:
				gridWidthClass = 'boost-pfs-filter-grid-width-5';
				break;
			case 6:
				gridWidthClass = 'boost-pfs-filter-grid-width-6';
				break;
			default:
				gridWidthClass = 'boost-pfs-filter-grid-width-4';
				break;
		}
		// On Mobile
		switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
			case 1:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-1';
				break;
			case 3:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-3';
				break;
			default:
				gridWidthClass += ' boost-pfs-filter-grid-width-mb-2';
				break;
		}
		return gridWidthClass;
	}

	function buildImages(data) {
		// This function was rebuilt by Plug.
		var html = [];

		html.push(
			'<img',
			'class="ratio-img full-width"',
			((window.innerWidth < 425 && itemIndex > 1) || itemIndex > 6) ? 'loading="lazy"' : '',
		);

		if (images[0]) {
			html.push(
				'srcset="' + PlugUtils.formatImageSrcset(
					images[0].src,
					data.images_info[0].width,
					[200, 300, 400, 600, 800, 1000, 1200]
				) + '"',
				'sizes="' + [
					"(max-width: 424px) calc(100vw - 44px)",
					"(max-width: 599px) calc((100vw - 128px) / 2)",
					"(max-width: 767px) calc((100vw - 196px) / 2)",
					"(max-width: 1023px) calc(((100vw - 100px) * .75 - 100px) / 2)",
					"(max-width: 1515px) calc(((100vw - 100px) * .75 - 160px) / 3)",
					"278px"
				].join(", ") + '"',
				'src="' + PlugUtils.formatImageSource(images[0].src, "600x") + '"',
			);
		} else {
			html.push('src="' + boostPFSImgDefaultSrc + '"')
		}

		html.push(
			'alt="' + data.title.replace(/"/g, "'") + '"',
			'draggable="false">'
		);

		// html.push(
		// 	'<img',
		// 	'class="ratio-img full-width lazyload"',
		// 	'loading="lazy"',
		// 	'src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="',
		// 	'data-src="' + src + '"',
		// 	'data-sizes="auto"',
		// 	'alt="' + data.title + '"',
		// 	'draggable="false">'
		// );

		return html.join(" ");
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor == true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	// const isoCodeToPrefix = {
	// 	HKD: "HK",
	// 	CAD: "C",
	// 	NZD: "NZ",
	// 	SGD: "S",
	// 	AUD: "A"
	// };
	// function buildPrice(price, compareAtPrice) {
	// 	var priceMoney = Utils.formatMoney(price);
	// 	if (Object.keys(isoCodeToPrefix).includes(PLUG.selectedCurrency)) {
	// 		priceMoney = isoCodeToPrefix[PLUG.selectedCurrency] + priceMoney;
	// 	}
	// 	var priceString = (
	// 		compareAtPrice && compareAtPrice > price
	// 		? 'Sale ' + priceMoney
	// 		: priceMoney
	// 	);
	// 	return '<span class="product-card-price">' + priceString + '</span>';
	// }
	//
	// function buildCompareAtPrice(price, compareAtPrice) {
	// 	var html = '';
	// 	if (compareAtPrice && compareAtPrice > price) {
	// 		var compareAtPriceMoney = Utils.formatMoney(compareAtPrice);
	// 		if (Object.keys(isoCodeToPrefix).includes(PLUG.selectedCurrency)) {
	// 			compareAtPriceMoney = isoCodeToPrefix[PLUG.selectedCurrency] + compareAtPriceMoney;
	// 		}
	// 		html += '<span class="product-card-compare-at-price">';
	// 		html += 'Reg. ' + compareAtPriceMoney;
	// 		html += '</span>';
	// 	} else {
	// 		html += '<span class="product-card-compare-at-price is-translucent"></span>';
	// 	}
	// 	return html;
	// }
	//
	// function buildSavings(price, compareAtPrice) {
	// 	var html = '';
	// 	if (compareAtPrice && compareAtPrice > price) {
	// 		var savingsMoney = Utils.formatMoney(compareAtPrice - price);
	// 		if (Object.keys(isoCodeToPrefix).includes(PLUG.selectedCurrency)) {
	// 			savingsMoney = isoCodeToPrefix[PLUG.selectedCurrency] + savingsMoney;
	// 		}
	// 		html += '<span class="product-card-price-savings">';
	// 		html += 'Save ' + savingsMoney;
	// 		html += '</span>';
	// 	} else {
	// 		html += '<span class="product-card-price-savings is-translucent"></span>';
	// 	}
	// 	return html;
	// }

	function buildLabels(data) {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_sold_out_label') &&
			boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '');
		}
		// Build Labels
		return soldOutLabel + saleLabel;
	}

	// BUILD LABEL PRODUCT WITH TAGS
	function buildTagLabels(data, showall) {
		if (boostPFSThemeConfig.custom.show_label_by_tag) {
			if (showall) {
				var tagLabel = '';
				if (data.tags) {
					for (var i = 0; i < data.tags.length; i++) {
						var tag = data.tags[i];
						if (tag.indexOf("pfs:label") !== -1) {
							var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
							tagLabel += preTagLabel;
						}
					}
				}
			} else {
				var tagLabel = '';
				if (data.tags) {
					for (var i = data.tags.length - 1; i >= 0; i--) {
						tag = data.tags[i];
						if (tag.indexOf("pfs:label") !== -1) {
							var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
							tagLabel += preTagLabel;
							break;
						}
					}
				}
			}
			return tagLabel;
		} else {
			return "";
		}
	}

	// Build Color Swatches
	function buildColorSwatches(data) {
		var colorSwatchesHtml = '',
			filterSwatchTitle = 'Color',
			optionName = 'color',
			swatchArr = [],
			countSwatch = 0,
			swatchValues = [],
			swatchLimit = 4;

		var dataImgSize = '360',
			bgSize = '50x',
			dataImgSrc = Utils.getFeaturedImage(data.images_info, dataImgSize + 'x'),
			swatchName = '#ffffff',
			bgImageSrc = '',
			viewMoreLabel = 'More ' + filterSwatchTitle;

		if (boostPFSThemeConfig.custom.hasOwnProperty('display_item_swatch') && boostPFSThemeConfig.custom.display_item_swatch == true) {
			if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0) {
				swatchArr = data.options_with_values.filter(function(option) {
					return option.name == optionName;
				});
				if (swatchArr.length > 0) {
					countSwatch = swatchArr[0].values.length;

					if (swatchLimit > countSwatch) {
						swatchLimit = countSwatch;
					}
					swatchValues = swatchArr[0].values;

					colorSwatchesHtml += '<ul class="boost-pfs-filter-item-swatch">';

					for (var sIndex = 0; sIndex < swatchLimit; sIndex++) {
						swatchName = swatchValues[sIndex].title;
						sImageIndex = swatchValues[sIndex].image || '';
						if (sImageIndex != '') {
							dataImgSrc = Utils.optimizeImage(data.images[sImageIndex], dataImgSize + 'x') + ' ' + dataImgSize + 'w';
						}


						if (boostPFSThemeConfig.custom.hasOwnProperty('swatch_color_display_type')) {
							switch (boostPFSThemeConfig.custom.swatch_color_display_type) {
								case 'swatch_color_display_type_image_color':
									bgImageSrc = boostPFSAppConfig.general.file_url.replace(/\?/, Utils.slugify(filterSwatchTitle).replace(/\-/g, '_') + '-' + Utils.slugify(swatchName) + '.png?v=');
									break;
								case 'swatch_color_display_type_image_product':
									bgImageSrc = Utils.getFeaturedImage(data.images_info, bgSize);
									if (sImageIndex != '') {
										bgImageSrc = Utils.optimizeImage(data.images[sImageIndex], bgSize);
									}
									break;
								default:
									bgImageSrc = '';
							}
						}

						colorSwatchesHtml += '<li>';
						colorSwatchesHtml += '<div class="boost-pfs-product-item-tooltip">' + swatchName + '</div>';
						colorSwatchesHtml += '<span tabindex="0" aria-label="' + swatchName + '" ' +
							'style="background-color: ' + swatchName + '; ';
						if (bgImageSrc != '') {
							colorSwatchesHtml += 'background-image: url(' + bgImageSrc + ');" ';
						} else {
							colorSwatchesHtml += '" ';
						}
						if (dataImgSrc != '') {
							colorSwatchesHtml += 'data-img="' + dataImgSrc + '" ';
						}

						colorSwatchesHtml += '></span>';
						colorSwatchesHtml += '</li>';
					}

					if (countSwatch > swatchLimit) {
						colorSwatchesHtml += '<li class="boost-pfs-filter-item-swatch-more">';
						colorSwatchesHtml += '<a href="{{itemUrl}}" title="' + viewMoreLabel + '">+' + (countSwatch - swatchLimit) + '</a>';
						colorSwatchesHtml += '</li>';
					}

					colorSwatchesHtml += '</ul>';
				}
			}
		}
		return colorSwatchesHtml;
	}

	// Build Color Swatches
	function eventColorSwatches(event) {
		jQ('.boost-pfs-filter-item-swatch li span').each(function() {
			var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
			if (event == 'hover') {
				jQ(this).hover(function() {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			if (event == 'click') {
				jQ(this).click(function() {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			jQ(this).focus(function() {
				if (jQ('body').hasClass('boost-pfs-ada')) {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				}
			});
		});
	}

	function buildReview(data) {
		var avgScore;
		var numReviews;
		if (data.metafields.length) {
			var reviewsScoreMetafield = data.metafields.find(function (metafield) {
				return metafield.namespace === "junip" && metafield.key === "rating_average";
			});
			var reviewsCountMetafield = data.metafields.find(function (metafield) {
				return metafield.namespace === "junip" && metafield.key === "rating_count";
			});
			if (reviewsCountMetafield && reviewsScoreMetafield) {
				avgScore = Number(reviewsScoreMetafield.value);
				numReviews = Number(reviewsCountMetafield.value);
			}

			// var numReviews = data.review_count;
			// var avgScore = (numReviews && numReviews > 0) ? data.review_ratings : 0;
			var html = '';

			html += PlugUtils.convertDomNodeToString(
				PlugUtils.buildStar(false, Math.round(avgScore))
			);

			if (Math.round(avgScore) !== 5) {
				html += PlugUtils.convertDomNodeToString(
					PlugUtils.buildStar(true, 5 - Math.round(avgScore))
				);
			}

			html += ' <span class="product-card-review-count">(' + numReviews + ')</span>';
		}

		return (
			!avgScore || !numReviews
			? '<span class="is-hidden">' + html + '</span>'
			: html
		);
		// var numReviews = data.review_count;
		// var avgScore = (numReviews && numReviews > 0) ? data.review_ratings : 0;
		// var html = '';
		//
		// html += PlugUtils.convertDomNodeToString(
		// 	PlugUtils.buildDiamond(false, Math.round(avgScore))
		// );
		//
		// if (Math.round(avgScore) !== 5) {
		// 	html += PlugUtils.convertDomNodeToString(
		// 		PlugUtils.buildDiamond(true, 5 - Math.round(avgScore))
		// 	);
		// }
		//
		// html += ' (' + numReviews + ')';
		//
        // return (
        //     avgScore === 0 || numReviews === 0
        //     ? '<span class="is-hidden">' + html + '</span>'
        //     : html
        // );
	}

	function buildActiveSwapClass(data) {
		if (!Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			boostPFSThemeConfig.custom.active_image_swap == true) {
			return 'has-bc-swap-image';
		}
		return '';
	}



	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {

		if (!totalProduct) totalProduct = this.totalProduct;
		console.log({totalProduct});
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};
// <li class="listbox-option f-p3 f-medium" role="option" {%- if option.selected_value == value %} aria-selected="true"{% endif %}>{{ value }}</li>

	function buildSortingOption(value, isSelected) {
		var html = '';
		html += '<li class="listbox-option f-p3 f-medium" role="option"';

		if (isSelected) {
			html += ' aria-selected="true"';
		}

		if (value === "Manual") {
			value = "Featured";
			html += " data-value='Manual'";
		}

		html += '>' + value + '</li>';

		return html;
	}

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		console.log("ProductSorting compile template", Utils.getSortingList());
		var html = '';
		// if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingObj = Utils.getSortingList();

			if (sortingObj) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				var activeValue = (PLUG.template === "collection") ? "Featured" : "Relevance";
				for (var k in sortingObj) {
					console.log("heard" + k);
					activeClass = '';
					if (paramSort == k) {
						activeClass = 'boost-pfs-filter-sort-item-active';
						activeValue = (
							sortingObj[k] === "Best Selling" || sortingObj[k] === "Manual"
							? "Featured"
							: sortingObj[k]
						);
						sortingItemsHtml += buildSortingOption(activeValue, true);
					} else {
						sortingItemsHtml += buildSortingOption(sortingObj[k], false);
					}
					// sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingOptions}}/g, sortingItemsHtml);
				html = html.replace(/{{initialValue}}/g, activeValue);
			}
		// }
		return html;
	};

	ProductSorting.prototype.render = function() {
		console.log("ProductSorting render", this.parent.productList.totalProduct);
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}
		console.log({Globals});
		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		console.log({sortingList});
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);

		if (typeof this.parent.productList.totalProduct === "number") {
			var countEle = document.getElementsByClassName("c-item-count")[0];
			if (countEle) {
				countEle.textContent = this.parent.productList.totalProduct + " Products";
			}
		}
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
			if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
				jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
			}
		});

		jQ(Selector.filterTreeMobileButton).click(function() {
			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		});

        try {
            PlugUtils.listboxConstructor(
    			document.getElementById("c-sorting-listbox"),
    			function onChange(option, listboxEle) {
    				const sortingObject = Utils.getSortingList();
    				const newSortType = Object.keys(sortingObject).find(function (key) {
    					return (
							sortingObject[key] === option.textContent
							|| sortingObject[key] === option.dataset.value
						);
    				});
    				if (newSortType) {
    					FilterApi.setParam('sort', newSortType);
    					FilterApi.setParam('page', 1);
    					FilterApi.applyFilter('sort');
    				}
    			}
    		);
        } catch (exception) {
            console.log("Error setting up sorting listbox.", exception);
        }

	};
	// For Toolbar - Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
		if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
			itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
			itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';

		} else {
			itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
			itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';

		}


		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Build Show Limit
	ProductLimit.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {

			var numberList = Settings.getSettingValue('general.showLimitList');
			if (numberList != '') {
				// Build content
				var showLimitItemsHtml = '';
				var arr = numberList.split(',');
				for (var k in sortingArr) {
					showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
				}
				html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			}
		}
		return html;
	};
	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function(colData) {
		if (!colData) colData = this.collectionData;
		var breadcrumbItemsHtml = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
				var colInfo = colData.collection;
				if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
					breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
				} else {
					breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
				}
			} else {
				breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
			}
		}
		return breadcrumbItemsHtml
	};

	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		// var productCards = document.getElementsByClassName("product-card");
		// var sprBadges = document.getElementsByClassName("spr-badge");
		// Intergrate Review Shopify
		// if (window.SPR &&
		// 	typeof window.SPR.initDomEls == 'function' &&
		// 	typeof window.SPR.loadBadges == 'function' &&
		// 	boostPFSThemeConfig.custom.show_product_review) {
		// 	// window.SPR.initDomEls();
		// 	// window.SPR.loadBadges();
		// 	// console.log("Heard");
		// 	// PlugUtils.waitUntilTrue(
		// 	// 	function () {
		// 	// 		return sprBadges.length;
		// 	// 	},
		// 	// 	function (data, reason) {
		// 	// 		if (reason) {
		// 	// 			console.log("Timed out waiting on review badges.");
		// 	// 		} else {
		// 	// 			formatBadges(sprBadges);
		// 	// 		}
		// 	// 	}
		// 	// );
		// }
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		var totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_other + '</span>';
		if (data.total_product == 1) {
			totalProduct = data.total_product + '<span> ' + boostPFSThemeConfig.label.items_with_count_one + '</span>';
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);

		jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

		// Prevent double tap on iOS
		var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
		if (isiOS) {
			Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function() {
				isScrolling = !1
			}).on("touchmove", function() {
				isScrolling = !0
			}).on("touchend", function() {
				isScrolling || (window.location = jQ(this).attr("href"))
			});
		}

		setupFilterButton();

		setupFilterRatingIcons();

		setupOptionToggleButtons();

        setupCollectionFilterButtons();

		// // Build Image Swap. Put this function here to impprove the pagespeed.
		// swapImage(data);
		//
		// // Build Equal Height
		// if (Globals.queryParams.display !== 'list') {
		// 	equalHeight(data);
		// };
		//
		// jQ(window).resize(function() {
		// 	if (Globals.queryParams.display !== 'list') {
		// 		equalHeight(data);
		// 	}
		// });
		//
		// // Build Event Color Swatch
		// if (boostPFSThemeConfig.custom.swatch_color_event_change_image != 'none') {
		// 	eventColorSwatches(boostPFSThemeConfig.custom.swatch_color_event_change_image);
		// }
		//
		// if (typeof boostRemoveImageLoadingAnimation == 'function') {
		// 	boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
		// }
	};

	ProductListPlaceholder.prototype.render = function() {
		// Set limit number for product skeleton
		var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
		// Build placeholder items
		var placeholderItem = this.compileTemplate();
		this.$element = [];
		for (var i = 0; i < placeholderLimit; i++) {
			this.$element.push(jQ(placeholderItem));
		}
		// Show placeholder before send filter request OR hide it after get filter data
		if (!this.isFetchedProductData) {
			this.setShow();
		} else {
			this.setHide();
		}
	}

	ProductListPlaceholder.prototype.compileTemplateExtra = function() {
		var display = Globals.queryParams.display
		switch (display) {
			case 'list':
				//Todo: Build placeholder for List mode
				var template = boostPFSTemplate.productListPlaceholderHtml;
				var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
				var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
				/**
				 * Set product class for product skeleton (to set column, style, etc.)
				 * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
				 */
				break;
		}
		return template
			.replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
			.replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
			.replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
			.replace(/{{paddingTop}}/g, imgRatio * 100)
	}

	/* Prevent conflict with theme vendor js */
	Array.prototype.insert = function(a, b) {}

	/* Math qual Height */
	function equalHeight(data) {
		var equal_i = -1;
		var equal_els = [];
		var equal_element = null;

		// Equal Height Title
		jQ('.boost-pfs-filter-product-item').each(function(i, element) {

			var offsetTop = jQ(element).offset().top;
			if (!equal_element || equal_element.offset().top !== offsetTop) {
				equal_element = jQ(element);
				equal_i++;
			}

			if (!equal_els[equal_i]) {
				equal_els[equal_i] = [];
			}
			equal_els[equal_i].push(element);
		});

		for (var i = 0; i < equal_els.length; i++) {
			var max = 0;
			var maxRatio = 0;
			var iLength = equal_els[i].length;

			for (var j = 0; j < equal_els[i].length; j++) {
				var item = equal_els[i][j];
				var height = jQ(item).find('.boost-pfs-filter-product-bottom-inner').height();
				max = Math.max(max, height);

			}

			jQ(equal_els[i]).find('.boost-pfs-filter-product-bottom-inner').css({ 'min-height': max });

		}

		var equal_height = boostPFSFilterConfig.general.equal_height;

		if (equal_height != 'false') {
			var cropImagePosition = boostPFSFilterConfig.general.cropImagePossitionEqualHeight;

			var widthImage = jQ('.boost-pfs-filter-product-item').width();
			var indexData = 0;

			// For Ratio
			if (equal_height != 'false' && equal_height != 'auto') {
				var heightImage = 0;
				var widthImage = jQ('.boost-pfs-filter-product-item').width();
				if (equal_height != 'false' && equal_height != 'auto') {
					var ratioWidthHeight = boostPFSThemeConfig.custom.equal_height;
				} else {
					var ratioWidthHeight = '';
				}

				var ratioWidthHeightOther = boostPFSThemeConfig.custom.ratio_width_height_other;
				if (ratioWidthHeightOther == '' && ratioWidthHeight == '') {
					return null;
				} else {
					if (ratioWidthHeightOther == '') {
						ratioWidthHeight = ratioWidthHeight.split(':');
						ratioWidthHeight = parseInt(ratioWidthHeight[1]) / parseInt(ratioWidthHeight[0]);
						heightImage = widthImage * ratioWidthHeight;
					} else if (ratioWidthHeightOther != '') {
						ratioWidthHeightOther = ratioWidthHeightOther.split(':');
						ratioWidthHeightOther = parseInt(ratioWidthHeightOther[1]) / parseInt(ratioWidthHeightOther[0]);
						heightImage = widthImage * ratioWidthHeightOther;
					}
				}
				jQ('.boost-pfs-filter-product-item-image-link').css({ 'padding-top': heightImage + 'px' }).addClass('boost-pfs-filter-crop-image-position-' + cropImagePosition);;

			}
		}
	}

	// Swap Image
	function swapImage(data) {
		if (!Utils.isMobile()) {
			if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
				boostPFSThemeConfig.custom.active_image_swap == true) {
				var dataSrcSetFlipImg = '',
					dataSrcFlipImg = '',
					flipImageAlt = '',
					dataSizes = 'auto',
					dataWidths = '',
					html = '';

				jQ(".boost-pfs-filter-product-item").each(function() {
					var productItemSelector = jQ(this);
					var imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');

					if (typeof imgSelector.data('img-flip-src') != 'undefined' &&
						imgSelector.data('img-flip-src') != '') {
						dataSrcFlipImg = imgSelector.data('img-flip-src');
						dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
						flipImageAlt = imgSelector.attr('alt');
						dataWidths = imgSelector.data('widths');
						html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
							'data-srcset="' + dataSrcSetFlipImg + '" ' +
							'data-src="' + dataSrcFlipImg + '" ' +
							'data-widths="[' + dataWidths + ']" ' +
							'data-sizes="' + dataSizes + '" ' +
							'src="' + boostPFSImgDefaultSrc + '" ' +
							'alt="' + flipImageAlt + '" />';

						productItemSelector.find('.boost-pfs-filter-product-item-image-link').prepend(html);
					}

				});
			}
		}
	}

	function buildProductItemUrl(data) {
		const productHandle = data.handle;
		const collectionPath = location.pathname;
		return `${collectionPath}/products/${productHandle}`;
	}

	// Build Placeholder for the first load
	function boostRemoveImageLoadingAnimation($selector) {
		if ($selector.length) {
			$selector.removeAttr('data-boost-image-loading-animation');
		}
	}

	// Additional Plug Functions

	function setupFilterButton() {
		var button = document.querySelector(".boost-pfs-filter-tree-mobile-button button");
		button.textContent = "Filter Results";
		button.appendChild(buildFilterIcon());
	}

	function buildFilterIcon() {
		var ns = "http://www.w3.org/2000/svg";
		var icon = document.createElementNS(ns, "svg");
		icon.classList.add("icon", "filter-icon");
		icon.style.transform = "rotate(90deg)";
		icon.style.transformOrigin = "center";
		PlugUtils.setAttributes(icon, {
			focusable: false,
			role: "presentation",
			viewBox: "0 0 20 16",
			width: "20",
			height: "16",
			fill: "none"
		});
		var path = document.createElementNS(ns, "path");
		path.setAttribute("d", `M9 12V1C9 0.734784 9.10536 0.48043 9.29289 0.292893C9.48043 0.105357 9.73478 0 10 0C10.2652 0 10.5196 0.105357 10.7071 0.292893C10.8946 0.48043 11 0.734784 11 1V12H12C12.2652 12 12.5196 12.1054 12.7071 12.2929C12.8946 12.4804 13 12.7348 13 13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14H11V15C11 15.2652 10.8946 15.5196 10.7071 15.7071C10.5196 15.8946 10.2652 16 10 16C9.73478 16 9.48043 15.8946 9.29289 15.7071C9.10536 15.5196 9 15.2652 9 15V14H8C7.73478 14 7.48043 13.8946 7.29289 13.7071C7.10536 13.5196 7 13.2652 7 13C7 12.7348 7.10536 12.4804 7.29289 12.2929C7.48043 12.1054 7.73478 12 8 12H9ZM16 2V1C16 0.734784 16.1054 0.48043 16.2929 0.292893C16.4804 0.105357 16.7348 0 17 0C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V2H19C19.2652 2 19.5196 2.10536 19.7071 2.29289C19.8946 2.48043 20 2.73478 20 3C20 3.26522 19.8946 3.51957 19.7071 3.70711C19.5196 3.89464 19.2652 4 19 4H18V15C18 15.2652 17.8946 15.5196 17.7071 15.7071C17.5196 15.8946 17.2652 16 17 16C16.7348 16 16.4804 15.8946 16.2929 15.7071C16.1054 15.5196 16 15.2652 16 15V4H15C14.7348 4 14.4804 3.89464 14.2929 3.70711C14.1054 3.51957 14 3.26522 14 3C14 2.73478 14.1054 2.48043 14.2929 2.29289C14.4804 2.10536 14.7348 2 15 2H16ZM4 5H5C5.26522 5 5.51957 5.10536 5.70711 5.29289C5.89464 5.48043 6 5.73478 6 6C6 6.26522 5.89464 6.51957 5.70711 6.70711C5.51957 6.89464 5.26522 7 5 7H4V15C4 15.2652 3.89464 15.5196 3.70711 15.7071C3.51957 15.8946 3.26522 16 3 16C2.73478 16 2.48043 15.8946 2.29289 15.7071C2.10536 15.5196 2 15.2652 2 15V7H1C0.734784 7 0.48043 6.89464 0.292893 6.70711C0.105357 6.51957 0 6.26522 0 6C0 5.73478 0.105357 5.48043 0.292893 5.29289C0.48043 5.10536 0.734784 5 1 5H2V1C2 0.734784 2.10536 0.48043 2.29289 0.292893C2.48043 0.105357 2.73478 0 3 0C3.26522 0 3.51957 0.105357 3.70711 0.292893C3.89464 0.48043 4 0.734784 4 1V5Z`);
		path.setAttribute("fill", "currentColor");
		icon.appendChild(path);
		return icon;
	}

	function setupFilterRatingIcons() {
		var oldFilterStars = document.getElementsByClassName("boost-pfs-filter-icon-star");
		PlugUtils.forEach(
			Array.from(oldFilterStars),
			function (oldStar) {
				var isEmpty = !oldStar.classList.contains("boost-pfs-filter-icon-star-active");
				var diamond = PlugUtils.buildDiamond(isEmpty);
				PlugUtils.replaceElement(oldStar, diamond);
			}
		);
	}

	function setupOptionToggleButtons() {
		var optionTitles = document.getElementsByClassName("boost-pfs-filter-option-title-heading");
		PlugUtils.forEach(optionTitles, function (optionTitle) {
			optionTitle.appendChild(buildOptionCaratIcon());
		});
	}

	function buildOptionCaratIcon() {
		var button = document.createElement("button");
		var ns = "http://www.w3.org/2000/svg";
		var svg = document.createElementNS(ns, "svg");
		PlugUtils.setAttributes(svg, {
			"aria-hidden": true,
			focusable: false,
			role: "presentation",
			width: "12",
			height: "8",
			viewBox: "0 0 12 8",
			fill: "none",
			class: "icon carat-down-icon",
			xmlns: "http://www.w3.org/2000/svg"
		});
		var path = document.createElementNS(ns, "path");
		PlugUtils.setAttributes(path, {
			d: "M11 1L6 6L1 1",
			stroke: "currentColor",
			"stroke-width": "2"
		});
		svg.appendChild(path);
		return svg;
	}

    function setupCollectionFilterButtons() {
        var collectionOption = document.getElementsByClassName("boost-pfs-filter-option-collection")[0];
        if (collectionOption) {
            var links = collectionOption.querySelectorAll(".boost-pfs-filter-option-content .boost-pfs-filter-button");
            PlugUtils.forEach(links, function (link) {
                link.addEventListener("click", function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    location.href = link.href + "?l1=" + PLUG.collection.handle + "|" + PLUG.collection.title;
                });
            });
        }
    }

    /* eslint-enable */
})();
